import React from "react";
import { Check } from "lucide-react";

export const checkPasswordRules = (password: string) => {
  const isMinLength = password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSymbol = /[^a-zA-Z0-9]/.test(password);
  return {
    isMinLength,
    hasUpperCase,
    hasNumber,
    hasSymbol,
    isValid: isMinLength && hasUpperCase && hasNumber && hasSymbol,
  };
};

interface PasswordValidatorProps {
  password: string;
  isDark: boolean;
}

export const PasswordValidator: React.FC<PasswordValidatorProps> = ({
  password,
  isDark,
}) => {
  const { isMinLength, hasUpperCase, hasNumber, hasSymbol } = checkPasswordRules(password);

  return (
    <div className={`flex flex-col gap-1.5 px-2 mt-[-6px] mb-2 transition-all ${isDark ? "text-white/60" : "text-gray-500"}`}>
      <div className="flex items-center gap-2 text-xs">
        {isMinLength ? (
          <Check size={13} className="text-emerald-500 flex-shrink-0" />
        ) : (
          <div className="w-[12px] h-[12px] rounded-full border border-current opacity-30 flex-shrink-0" />
        )}
        <span className={isMinLength ? "text-emerald-500 font-medium" : ""}>Mínimo 8 caracteres</span>
      </div>
      <div className="flex items-center gap-2 text-xs">
        {hasUpperCase ? (
          <Check size={13} className="text-emerald-500 flex-shrink-0" />
        ) : (
          <div className="w-[12px] h-[12px] rounded-full border border-current opacity-30 flex-shrink-0" />
        )}
        <span className={hasUpperCase ? "text-emerald-500 font-medium" : ""}>Al menos una letra mayúscula</span>
      </div>
      <div className="flex items-center gap-2 text-xs">
        {hasNumber ? (
          <Check size={13} className="text-emerald-500 flex-shrink-0" />
        ) : (
          <div className="w-[12px] h-[12px] rounded-full border border-current opacity-30 flex-shrink-0" />
        )}
        <span className={hasNumber ? "text-emerald-500 font-medium" : ""}>Al menos un número</span>
      </div>
      <div className="flex items-center gap-2 text-xs">
        {hasSymbol ? (
          <Check size={13} className="text-emerald-500 flex-shrink-0" />
        ) : (
          <div className="w-[12px] h-[12px] rounded-full border border-current opacity-30 flex-shrink-0" />
        )}
        <span className={hasSymbol ? "text-emerald-500 font-medium" : ""}>Al menos un símbolo (!@#$...)</span>
      </div>
    </div>
  );
};
